import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "field mt-2" }
const _hoisted_2 = { class: "field mt-2" }
const _hoisted_3 = { class: "field mt-2" }
const _hoisted_4 = { class: "field mt-2" }
const _hoisted_5 = { class: "dialog-footer flex justify-content-between" }

import { onMounted, Ref } from 'vue';
import useVuelidate from '@vuelidate/core';
import { email, required } from '@vuelidate/validators';

import { EMIT } from '@/enum';
import { useTenantStore, useTimezoneStore } from '@/store';
import { storeToRefs } from 'pinia';


export default /*@__PURE__*/_defineComponent({
  __name: 'AddAdmin',
  emits: [EMIT.SAVE, EMIT.BACK],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const timezoneStore = useTimezoneStore();
const tenantStore = useTenantStore();

/**
 * The data ref object for newAdmin so you can come back to the data.
 */
const { newAdmin } = storeToRefs(tenantStore);

/**
 * The required validation rules.
 */
const rules = {
  first_name: { required },
  last_name: { required },
  email: { required, email },
  timezone_id: { required },
  timezone: { required },
  timezone_object: { required },
};

/**
 * Initialize the vuelidate instance.
 */
const v$ = useVuelidate(rules, newAdmin);

onMounted(() => {
  init();
});

const init = async () => await timezoneStore.getTimezones();

/**
 * Handle the client side validation, followed by saving the
 * information for the new user account.
 */
const onSave = () => {
  if (v$.value.$invalid) return;
  emit(EMIT.SAVE);
};

const goBack = () => emit(EMIT.BACK);

const handleTimezoneChange = (zone: Ref) => {
  newAdmin.value.timezone = zone.value.name;
  newAdmin.value.timezone_id = zone.value.id;
};

return (_ctx: any,_cache: any) => {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[4] || (_cache[4] = _createElementVNode("label", {
        class: "required",
        for: "name"
      }, "First Name", -1)),
      _createVNode(_component_InputText, {
        id: "first_name",
        modelValue: _unref(v$).first_name.$model,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).first_name.$model) = $event)),
        type: "text",
        placeholder: "First Name",
        class: "w-full"
      }, null, 8, ["modelValue"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).first_name.$errors, (error) => {
        return (_openBlock(), _createElementBlock("div", {
          key: error.$uid,
          class: "input-errors"
        }, [
          _createElementVNode("small", null, _toDisplayString(error.$message), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("label", {
        class: "required",
        for: "name"
      }, "Last Name", -1)),
      _createVNode(_component_InputText, {
        id: "last_name",
        modelValue: _unref(v$).last_name.$model,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).last_name.$model) = $event)),
        type: "text",
        placeholder: "Last Name",
        class: "w-full"
      }, null, 8, ["modelValue"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).last_name.$errors, (error) => {
        return (_openBlock(), _createElementBlock("div", {
          key: error.$uid,
          class: "input-errors"
        }, [
          _createElementVNode("small", null, _toDisplayString(error.$message), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[6] || (_cache[6] = _createElementVNode("label", {
        class: "required",
        for: "street"
      }, "Email", -1)),
      _createVNode(_component_InputText, {
        id: "email",
        modelValue: _unref(v$).email.$model,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).email.$model) = $event)),
        type: "email",
        placeholder: "Email",
        class: "w-full"
      }, null, 8, ["modelValue"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).email.$errors, (error) => {
        return (_openBlock(), _createElementBlock("div", {
          key: error.$uid,
          class: "input-errors"
        }, [
          _createElementVNode("small", null, _toDisplayString(error.$message), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[7] || (_cache[7] = _createElementVNode("label", {
        class: "required",
        for: "timezone"
      }, "Timezone", -1)),
      _createVNode(_component_Dropdown, {
        id: "timezone",
        modelValue: _unref(v$).timezone_object.$model,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).timezone_object.$model) = $event)),
        options: _unref(timezoneStore).timezones,
        "option-label": "name",
        placeholder: "Select a Timezone",
        class: "w-full",
        onChange: handleTimezoneChange
      }, null, 8, ["modelValue", "options"]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(v$).timezone.$errors, (error) => {
        return (_openBlock(), _createElementBlock("div", {
          key: error.$uid,
          class: "input-errors"
        }, [
          _createElementVNode("small", null, _toDisplayString(error.$message), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_AppButton, {
        "icon-left": "arrow_back",
        type: "secondary",
        text: "Back",
        class: "ml-0 admin-button",
        onClick: goBack
      }),
      _createVNode(_component_AppButton, {
        "icon-left": "arrow_forward",
        type: "secondary",
        text: "Create Tenant",
        class: "admin-button cursor-pointer",
        disabled: _unref(v$).$invalid,
        onClick: onSave
      }, null, 8, ["disabled"])
    ])
  ], 64))
}
}

})